module.exports = __webpack_public_path__ + "img/check.9f2ffa72.svg";